import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailAddressComponent } from './components/detail-address/detail-address.component';
import { PopupViewContainerComponent } from './components/popup-view-container/popup-view-container.component';
import { DetailDescriptionComponent } from './components/detail-description/detail-description.component';
import { DetailFactoidComponent } from './components/detail-factoid/detail-factoid.component';
import { DetailImageComponent } from './components/detail-image/detail-image.component';
import { DetailSectionComponent } from './components/detail-section/detail-section.component';
import { DetailTagsComponent } from './components/detail-tags/detail-tags.component';
import { DetailContentComponent } from './components/detail-content/detail-content.component';
import { DetailTitleComponent } from './components/detail-title/detail-title.component';
import { DetailWeblinkComponent } from './components/detail-weblink/detail-weblink.component';
import { DetailViewContainerComponent } from './components/detail-view-container/detail-view-container.component';
import { SkeletonModule } from 'primeng/skeleton';
import { DetailTableComponent } from './components/detail-table/detail-table.component';
import { DetailTableRowComponent } from './components/detail-table-row/detail-table-row.component';
import { ListViewContainerComponent } from './components/list-view-container/list-view-container.component';

@NgModule({
    declarations: [
        DetailAddressComponent,
        PopupViewContainerComponent,
        DetailViewContainerComponent,
        DetailDescriptionComponent,
        DetailFactoidComponent,
        DetailImageComponent,
        DetailSectionComponent,
        DetailTagsComponent,
        DetailContentComponent,
        DetailTitleComponent,
        DetailWeblinkComponent,
        DetailTableComponent,
        DetailTableRowComponent,
        ListViewContainerComponent,
    ],
    imports: [
        CommonModule,
        SkeletonModule,
    ],
    exports: [
        DetailAddressComponent,
        PopupViewContainerComponent,
        DetailViewContainerComponent,
        DetailDescriptionComponent,
        DetailFactoidComponent,
        DetailImageComponent,
        DetailSectionComponent,
        DetailTagsComponent,
        DetailContentComponent,
        DetailTitleComponent,
        DetailWeblinkComponent,
        DetailTableComponent,
        DetailTableRowComponent,
        ListViewContainerComponent,
    ],
})
export class DetailViewModule {
}
